// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DispositiveProvisionTemplateUseCount_DispositionScenarioFragment = { __typename?: 'DispositionScenario', id: string, firstGrantorDeath: { __typename?: 'ClientProfile', id: string, displayGivenName: string }, dispositiveProvisionsTemplate?: { __typename?: 'DispositiveProvisionTemplate', id: string } | null, secondDeathDispositiveProvisionsTemplate?: { __typename?: 'DispositiveProvisionTemplate', id: string } | null };

export type DispositiveProvisionTemplateUseCount_EntityFragment = { __typename?: 'Entity', id: string, subtype: { __typename: 'CCorpBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'CLTTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'CRTTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'CustodialPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'DonorAdvisedFund', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'GPBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'GRATTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'ILITTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'IndividualPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'InsurancePersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'IrrevocableTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'JointPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'LLCBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'LPBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'PrivateFoundation', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'QPRTTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'RetirementPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'RevocableTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'SCorpBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'SLATTrust', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } | { __typename: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<(
      { __typename?: 'DispositionScenario' }
      & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
    )> | null } };

export type DispositiveProvisionTemplateUseCount_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string, dispositionScenarios?: Array<(
    { __typename?: 'DispositionScenario' }
    & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
  )> | null };

export type DispositiveProvisionTemplateUseCount_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, dispositionScenarios?: Array<(
    { __typename?: 'DispositionScenario' }
    & DispositiveProvisionTemplateUseCount_DispositionScenarioFragment
  )> | null };

export type DispositiveProvisionTemplateUseCountQueryVariables = Types.Exact<{
  entityWhere: Types.EntityWhereInput;
  testamentaryEntityWhere: Types.TestamentaryEntityWhereInput;
  individualWhere: Types.ClientProfileWhereInput;
}>;


export type DispositiveProvisionTemplateUseCountQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', totalCount: number, edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & DispositiveProvisionTemplateUseCount_EntityFragment
      ) | null } | null> | null }, testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', totalCount: number, edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & DispositiveProvisionTemplateUseCount_TestamentaryEntityFragment
      ) | null } | null> | null }, clientProfiles: { __typename?: 'ClientProfileConnection', totalCount: number, edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & DispositiveProvisionTemplateUseCount_ClientProfileFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DispositiveProvisionTemplateUseCount: 'DispositiveProvisionTemplateUseCount' as const
  },
  Fragment: {
    DispositiveProvisionTemplateUseCount_DispositionScenario: 'DispositiveProvisionTemplateUseCount_DispositionScenario' as const,
    DispositiveProvisionTemplateUseCount_Entity: 'DispositiveProvisionTemplateUseCount_Entity' as const,
    DispositiveProvisionTemplateUseCount_TestamentaryEntity: 'DispositiveProvisionTemplateUseCount_TestamentaryEntity' as const,
    DispositiveProvisionTemplateUseCount_ClientProfile: 'DispositiveProvisionTemplateUseCount_ClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DispositiveProvisionTemplateUseCount_DispositionScenarioFragmentDoc = gql`
    fragment DispositiveProvisionTemplateUseCount_DispositionScenario on DispositionScenario {
  id
  firstGrantorDeath {
    id
    displayGivenName
  }
  dispositiveProvisionsTemplate {
    id
  }
  secondDeathDispositiveProvisionsTemplate {
    id
  }
}
    `;
export const DispositiveProvisionTemplateUseCount_EntityFragmentDoc = gql`
    fragment DispositiveProvisionTemplateUseCount_Entity on Entity {
  id
  subtype {
    __typename
    id
    displayName
    dispositionScenarios {
      ...DispositiveProvisionTemplateUseCount_DispositionScenario
    }
  }
}
    ${DispositiveProvisionTemplateUseCount_DispositionScenarioFragmentDoc}`;
export const DispositiveProvisionTemplateUseCount_TestamentaryEntityFragmentDoc = gql`
    fragment DispositiveProvisionTemplateUseCount_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
  dispositionScenarios {
    ...DispositiveProvisionTemplateUseCount_DispositionScenario
  }
}
    ${DispositiveProvisionTemplateUseCount_DispositionScenarioFragmentDoc}`;
export const DispositiveProvisionTemplateUseCount_ClientProfileFragmentDoc = gql`
    fragment DispositiveProvisionTemplateUseCount_ClientProfile on ClientProfile {
  id
  displayName
  dispositionScenarios {
    ...DispositiveProvisionTemplateUseCount_DispositionScenario
  }
}
    ${DispositiveProvisionTemplateUseCount_DispositionScenarioFragmentDoc}`;
export const DispositiveProvisionTemplateUseCountDocument = gql`
    query DispositiveProvisionTemplateUseCount($entityWhere: EntityWhereInput!, $testamentaryEntityWhere: TestamentaryEntityWhereInput!, $individualWhere: ClientProfileWhereInput!) {
  entities(where: $entityWhere) {
    totalCount
    edges {
      node {
        ...DispositiveProvisionTemplateUseCount_Entity
      }
    }
  }
  testamentaryEntities(where: $testamentaryEntityWhere) {
    totalCount
    edges {
      node {
        ...DispositiveProvisionTemplateUseCount_TestamentaryEntity
      }
    }
  }
  clientProfiles(where: $individualWhere) {
    totalCount
    edges {
      node {
        ...DispositiveProvisionTemplateUseCount_ClientProfile
      }
    }
  }
}
    ${DispositiveProvisionTemplateUseCount_EntityFragmentDoc}
${DispositiveProvisionTemplateUseCount_TestamentaryEntityFragmentDoc}
${DispositiveProvisionTemplateUseCount_ClientProfileFragmentDoc}`;

/**
 * __useDispositiveProvisionTemplateUseCountQuery__
 *
 * To run a query within a React component, call `useDispositiveProvisionTemplateUseCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositiveProvisionTemplateUseCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositiveProvisionTemplateUseCountQuery({
 *   variables: {
 *      entityWhere: // value for 'entityWhere'
 *      testamentaryEntityWhere: // value for 'testamentaryEntityWhere'
 *      individualWhere: // value for 'individualWhere'
 *   },
 * });
 */
export function useDispositiveProvisionTemplateUseCountQuery(baseOptions: Apollo.QueryHookOptions<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>(DispositiveProvisionTemplateUseCountDocument, withFetchPolicyContext(options));
      }
export function useDispositiveProvisionTemplateUseCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>(DispositiveProvisionTemplateUseCountDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositiveProvisionTemplateUseCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>(DispositiveProvisionTemplateUseCountDocument, withFetchPolicyContext(options));
        }
export type DispositiveProvisionTemplateUseCountQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplateUseCountQuery>;
export type DispositiveProvisionTemplateUseCountLazyQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplateUseCountLazyQuery>;
export type DispositiveProvisionTemplateUseCountSuspenseQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplateUseCountSuspenseQuery>;
export type DispositiveProvisionTemplateUseCountQueryResult = Apollo.QueryResult<DispositiveProvisionTemplateUseCountQuery, DispositiveProvisionTemplateUseCountQueryVariables>;